import React from "react";
import PropTypes from "prop-types";

const defaultData = {
  average_tariff: ["-", "-"],
  total_population: ["-", "-"],
  urban_population: ["-", "-"],
  people_connected_to_water: ["-", "-"],
  people_connected_to_wastewater: ["-", "-"],
};

const SectorStructure = ({ data = defaultData, icons, selectedCountryName, slug }) => {
  const {
    dropletFullIcon,
    dropletHalfIcon,
    peopleIcon,
    tariffIcon,
    urbanIcon,
  } = icons;

  const {
    average_tariff,
    total_population,
    urban_population,
    percentage_connected_to_water,
    percentage_connected_to_wastewater,
  } = data;

  const castNumberOrNot = num => {
    if (num == 100.0) {
      return "100%";
    }
    return num ? `${Number(num).toPrecision(2)}%` : "-";
  };

  return (
    <div className="sector-structure">
      <div className="title">
        Country indicators -&nbsp;
        <span>
          <a
            href={`/markets/countries/${slug}`}
            className="country-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {selectedCountryName}
          </a>
        </span>
      </div>
      <div className="sector-structure-data">
        <div className="figure-wrapper">
          <span className="figure-icon-wrapper">
            <img src={tariffIcon} alt="utility" className="key-figures-icon" />
          </span>
          <span className="figures">
            <span className="bold">$US {average_tariff[0] ? average_tariff[0] : "-"}/m<sup>3</sup></span>&nbsp;
            <a
              href={`/markets/countries/${slug}#tariffs`}
              className="country-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              average tariff
            </a>
          </span>
        </div>
        <div className="figure-wrapper">
          <span className="figure-icon-wrapper">
            <img src={peopleIcon} alt="utility" className="key-figures-icon" />
          </span>
          <span className="figures">
            <span className="bold">{total_population[0] ? total_population[0] : "-"}</span>&nbsp;total population
            <span className="year">&nbsp;{total_population[1] ? `${total_population[1]}` : ""}</span>
          </span>
        </div>
        <div className="figure-wrapper">
          <span className="figure-icon-wrapper">
            <img src={urbanIcon} alt="utility" className="key-figures-icon" />
          </span>
          <span className="figures">
            <span className="bold">{urban_population && castNumberOrNot(urban_population[0])}</span>&nbsp;population in urban areas
            <span className="year">&nbsp;{urban_population[1] ? `${urban_population[1]}` : ""}</span>
          </span>
        </div>
        <div className="figure-wrapper">
          <span className="figure-icon-wrapper">
            <img src={dropletFullIcon} alt="utility" className="key-figures-icon" />
          </span>
          <span className="figures">
            <span className="bold">{percentage_connected_to_water && castNumberOrNot(percentage_connected_to_water[0])}</span>&nbsp;
            <a
              href={`/markets/countries/${slug}#water-and-wastewater-indicators`}
              className="country-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              connected to water network
            </a>
            <span className="year">
              &nbsp;{percentage_connected_to_water && percentage_connected_to_water[1] ? `${percentage_connected_to_water[1]}` : ""}
            </span>
          </span>
        </div>
        <div className="figure-wrapper">
          <span className="figure-icon-wrapper">
            <img src={dropletHalfIcon} alt="utility" className="key-figures-icon" />
          </span>
          <span className="figures">
            <span className="bold">{percentage_connected_to_wastewater && castNumberOrNot(percentage_connected_to_wastewater[0])}</span>&nbsp;
            <a
              href={`/markets/countries/${slug}#water-and-wastewater-indicators`}
              className="country-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              connected to wastewater network
            </a>
            <span className="year">&nbsp;
                {percentage_connected_to_wastewater && percentage_connected_to_wastewater[1] ? `${percentage_connected_to_wastewater[1]}` : ""}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

SectorStructure.propTypes = {
  data: PropTypes.shape({}),
  icons: PropTypes.shape({}),
  selectedCountryName: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

export default SectorStructure;
